import React, { useState } from 'react';
import { Container, Row, Col } from 'reactstrap';

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqs = [
    {
      question: 'Come funziona il servizio di televideovisita?',
      answer:
        'Il servizio di televideovisita ti permette di consultare un medico generico 24 ore su 24, 7 giorni su 7, direttamente dal tuo smartphone o computer. Basta accedere alla piattaforma, selezionare il medico disponibile e iniziare la videochiamata. Il medico potrà valutare i tuoi sintomi, fornire consigli e darti indicazioni. Post consulto riceverai un report riepilogativo del medico con cui hai parlato.',
    },
    {
      question:
        'Una volta effettuato il pagamento, quanto potrò consultare il medico?',
      answer:
        'Il servizio sarà immediatamente attivo, quindi potrai conttattare subito il medico e ricevere immediata assistenza. Anche nel cuore della notte, potrai attivare SOS Dottore e ottenere subito il numero da chiamare per avere assistenza medica tutte le volte che vorrai.',
    },
    {
      question: 'Ci sono altri costi oltre al prezzo del piano?',
      answer:
        'No, il prezzo del piano include tutti i servizi inclusi, non ci sono costi aggiuntivi. Potrai contattare i nostri medici in qualsiasi momento, 24 ore su 24, 7 giorni su 7, senza alcun costo aggiuntivo. Potrai usufuruire delle convenzioni con i nostri partner sanitari e odontoiatrici ogni volta che vorrai e utilizzare Doc24 per il monitorraggio dei tuoi parametri vitali e videochiamare il medico ogni volta che lo desideri.',
    },
    {
      question: 'Il medico può prescrivere farmaci?',
      answer:
        'Il medico, a sua completa discrezione, può decidere di prescrivere farmaci se lo riterrà necessario. In questo caso, lo farà solo su ricetta "bianca" quindi senza convenzione con il Sistema Sanitario Nazionale (SSN).',
    },
    {
      question: 'Posso includere i miei familiari nel piano?',
      answer:
        'Sì, con il piano di abbonamento puoi includere fino a 3 familiari oltre al sottoscrivente. Ogni membro della famiglia avrà accesso a tutti i servizi inclusi nel piano, comprese le televideovisite e le convenzioni.',
    },
    {
      question: 'Come funziona il rinnovo automatico?',
      answer:
        'Il piano si rinnova automaticamente alla scadenza del periodo di abbonamento. Puoi disattivare il rinnovo automatico in qualsiasi momento dalla tua area personale, prima della scadenza.',
    },
    {
      question: 'Quali sono i vantaggi del piano semestrale?',
      answer:
        'Il piano semestrale offre un risparmio significativo rispetto al piano mensile. Inoltre, con un unico pagamento hai la certezza di avere accesso ai servizi per 6 mesi, senza preoccuparti dei rinnovi mensili.',
    },
    {
      question: 'Posso cambiare piano in qualsiasi momento?',
      answer:
        'Sì, puoi cambiare piano in qualsiasi momento. Il nuovo piano entrerà in vigore alla scadenza del periodo di abbonamento corrente. Non ci sono costi aggiuntivi per il cambio di piano.',
    },
  ];

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="faq">
      <Container>
        <Row className="justify-content-center">
          <Col lg={8} className="text-center">
            <h2 className="faq__title">Domande Frequenti</h2>
            <p className="faq__subtitle">
              Trova le risposte alle domande più comuni sul nostro servizio
            </p>
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Col lg={8}>
            <div className="faq__list">
              {faqs.map((faq, index) => (
                <div
                  key={index}
                  className={`faq__item ${
                    activeIndex === index ? 'active' : ''
                  }`}>
                  <div
                    className="faq__question"
                    onClick={() => toggleFAQ(index)}>
                    <h3>{faq.question}</h3>
                    <span className="faq__icon">
                      {activeIndex === index ? '−' : '+'}
                    </span>
                  </div>
                  <div className="faq__answer">
                    <p>{faq.answer}</p>
                  </div>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default FAQ;
